import AbstractFormulaVisitor from "../../../keyFigure/formula/visitors/AbstractFormulaVisitor.js";
import ReportReferenceFormulaNode from "../../templates/ReportReferenceFormulaNode.js";

/**
 * Serialize a FormulaColumn's formula. Contrary to FormulaRow's
 * formula, we don't want to replace instances of ReportReferenceNode
 * with account specifications. We want to send the report references
 * to the server as they are but replace the reference id to target
 * instances of items instead of templates.
 *
 * @param {Report} report - An instance of a report template. This is
 * used to map a template id to a report's item.
 */
export default class FormulaColumnFormulaSerializer extends AbstractFormulaVisitor {
	constructor({ report }) {
		super(...arguments);

		this._report = report;
	}

	visitReportReferenceNode(node) {
		// Transform a report reference node into another one with an
		// item id instead of an item template id.

		const referencedItemTemplate = node.getReference();

		const referencedItem = this._report.findItemWithTemplate(
			referencedItemTemplate,
		);

		return new ReportReferenceFormulaNode({
			referenceId: referencedItem.getId(),
		});
	}

	visitBinaryOperatorNode(node) {
		return new node.constructor({
			leftOperand: node.getLeftOperand().accept(this),
			rightOperand: node.getRightOperand().accept(this),
		});
	}

	visitSumNode(node) {
		return new node.constructor({
			operands: node.getOperands().map((op) => op.accept(this)),
		});
	}
}
